import styled from 'styled-components';

export const Popup = styled.div`
    background: rgba(0,0,0,.6);
    outline: 0;
    overflow: hidden;
    position: fixed;
    transition: opacity 0.3s ease;
    top: 0;
    left: 0;
    margin: 0;
    width: 100vw;
    height: 100vh;
    filter: none;
`;

export const PopupWrapper = styled.div`
    overflow: auto;
    overflow-x: hidden;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: flex-start;
    @media only screen and (max-width: 640px) {
        display: block;
        vertical-align: inherit;
    }
`;


export const PopupContent = styled.div`
    margin: 0 auto;
    transition: margin .3s ease;
    background: #fff;
    max-width: 680px;
    padding: 40px;
    position: relative;
    top: auto;
    left: auto;
    bottom: auto;
    right: auto;
    box-shadow: 0 2px 4px rgba(0,0,0,.3);
    @media only screen and (max-width: 1187px) {
        padding: 50px 20px 40px;
    }
`;

export const PopupClose = styled.div`
    width: 26px;
    height: 26px;
    position: absolute;
    top: 15px;
    right: 30px;
    cursor: pointer;
    background: 0 0;
    transform: rotate(45deg);
    transition: all .2s linear;
    z-index: 9999;
    &:hover:after {
        background: #ed1c24
    }
    &:hover:before {
        background: #ed1c24
    }
    &:before {
        content: '';
        width: 2px;
        background: #000;
        height: 24px;
        left: 50%;
        top: 50%;
        position: absolute;
        margin-top: -11px;
        transition: all .2s linear;
    }
    &:after {
        content: '';
        height: 2px;
        background: #000;
        width: 24px;
        left: 50%;
        top: 50%;
        position: absolute;
        margin-left: -11px;
        transition: all .2s linear;
    }
`;

export const City = styled.div`
    width: 100%;
    position: relative;
    font-family: CoFoSansBold, Helvetica, sans-serif;
`;

export const FavoriteCity = styled.div`
    @media only screen and (max-width: 640px) {
        margin: 20px 0;
    }
`;

export const Title = styled.h2`
    margin-bottom: 20px;
    font-family: CoFoSansBold, Helvetica, sans-serif;
    font-size: 40px;
    font-style: normal;
    font-weight: 400;
    line-height: 50px;
    @media only screen and (max-width: 640px) {
        margin-bottom: 20px;
        font-size: 28px;
        line-height: 35px;
    }
`;
export const Line = styled.div`
    width: 100%;
    height: 1px;
    overflow: hidden;
    background: #d8d8d8;
    margin-top: 10px;
`;
interface ILink {
    fz14?: string,
}
export const Link = styled.a<ILink>`
    float: left;
    margin-right: 40px;
    padding: 18px 0;
    cursor: pointer;
    display: block;
    text-decoration: none;
    color: #000;
    font-family: CoFoSansBold, Helvetica, sans-serif;
    font-size: ${props => props.fz14 ? '14px' : '20px'}
    font-style: normal;
    font-weight: 400;
    line-height: 25px;
    transition: color .2s linear;
    &:hover {
        color: #ed1c24;
        transition: color .2s linear;
    }
    @media only screen and (max-width: 640px) {
        float: none;
        font-family: CoFoSansBold, Helvetica, sans-serif;
        padding: 0;
        margin-bottom: 10px;
        font-size: 15px;
        font-weight: 400;
        line-height: 25px;
    }
`;

export const CityWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    justify-content: space-between;
    height: 805px;
    @media only screen and (max-width: 1187px) {
        height: auto;
    }
`;

export const CityBlock = styled.div`
    width: 135px;
    margin-top: 25px;
    margin-bottom: 5px;
    overflow: hidden;
    position: relative;
    @media only screen and (max-width: 640px) {
        padding-left: 50px;
        margin-bottom: 10px;
        padding-bottom: 10px;
    }
`;

export const CityMainLetter = styled.div`
    color: #ed1c24;
    font-size: 20px;
    line-height: 20px;
    text-transform: uppercase;
    margin-bottom: 15px;
    @media only screen and (max-width: 640px) {
        position: absolute;
        top: 4px;
        left: 0;
    }
`;

export const CityContainer = styled.div`
    width: 100%;
    margin-bottom: 15px;
`;

export const LinkCity = styled(Link)`
    float: none;
    font-family: CoFoSansBold, Helvetica, sans-serif;
    padding: 0;
    margin-right: 0px;
    font-size: 14px;
    color: #000;
    text-decoration: underline;
    display: inline;
    cursor: pointer;
    -webkit-transition: .2s all linear;
    transition: .2s all linear;
`;
